// /opt/isp_erp/frontend/src/api/tickets.api.js
import axios from './axios';

export const ticketsAPI = {
  // Crear ticket
  create: async (data) => {
    const response = await axios.post('/tickets/', data);
    return response.data;
  },

  // Reabrir ticket
  reopenTicket: async (id, motivo) => {
    const response = await axios.post(`/tickets/${id}/reopen`, { motivo });
    return response.data;
  },

  // Listar tickets
  list: async (params = {}) => {
    const response = await axios.get('/tickets/', { params });
    return response.data;
  },


  // Obtener tickets por cliente
  getTicketsByCustomer: async (customerId) => {
    const response = await axios.get(`/tickets/cliente/${customerId}`);
    return response.data;
  },

  // Obtener estadísticas
  getStats: async () => {
    const response = await axios.get('/tickets/stats');
    return response.data;
  },

  // Obtener alertas SLA
  getSlaAlerts: async () => {
    const response = await axios.get('/tickets/sla-alerts');
    return response.data;
  },

  // Obtener técnicos
  getTechnicians: async () => {
    const response = await axios.get('/tickets/technicians');
    return response.data;
  },

  // Obtener ticket por ID
  getById: async (id) => {
    const response = await axios.get(`/tickets/${id}`);
    return response.data;
  },

  // Actualizar diagnóstico
  updateDiagnostic: async (id, data) => {
    const response = await axios.put(`/tickets/${id}/diagnostic`, data);
    return response.data;
  },

  // Programar visita
  scheduleVisit: async (id, visitDate, technicianId) => {
    const response = await axios.put(`/tickets/${id}/schedule-visit`, null, {
      params: { visit_date: visitDate, technician_id: technicianId }
    });
    return response.data;
  },

  // Actualizar trabajo de campo
  updateFieldWork: async (id, data) => {
    const response = await axios.put(`/tickets/${id}/field-work`, data);
    return response.data;
  },

  // Resolver ticket
  resolve: async (id, data) => {
    const response = await axios.put(`/tickets/${id}/resolve`, data);
    return response.data;
  },

  // Cerrar ticket
  close: async (id) => {
    const response = await axios.put(`/tickets/${id}/close`);
    return response.data;
  },

  // Agregar comentario
  addComment: async (id, data) => {
    const response = await axios.post(`/tickets/${id}/comments`, data);
    return response.data;
  },

  // Eliminar ticket
  deleteTicket: async (id) => {
    const response = await axios.delete(`/tickets/${id}`);
    return response.data;
  },

  // ==================== NUEVOS MÉTODOS PARA ÓRDENES DE TRABAJO ====================

  // Crear ticket de instalación
  createInstalacionTicket: async (data) => {
    const response = await axios.post('/tickets/instalacion', data);
    return response.data;
  },

  // Crear ticket de retiro
  createRetiroTicket: async (data) => {
    const response = await axios.post('/tickets/retiro', data);
    return response.data;
  },

  // Crear ticket de cambio de equipo
  createCambioEquipoTicket: async (data) => {
    const response = await axios.post('/tickets/cambio-equipo', data);
    return response.data;
  },

  // Cerrar ticket de instalación
  closeInstalacionTicket: async (ticketId, materialesIds, equipos = [], ubicacion = null, napData = null, fotos = [], vinetaData = null, fichaNumero = null) => {
   // Construir payload base
    const payload = {
      materiales_ids: materialesIds,
      equipos: equipos
    };

    // Si hay ubicación, agregarla al payload
    if (ubicacion && ubicacion.latitud && ubicacion.longitud) {
      payload.latitud = ubicacion.latitud;
      payload.longitud = ubicacion.longitud;
      payload.precision = ubicacion.precision || null;
      payload.ubicacion_obtenida_en = 'gps';
    }

    // Agregar datos del NAP si existen
    if (napData) {
      payload.nap_id = napData.nap_id;
      payload.puerto_nap = napData.puerto_nap;
      payload.nivel_senal_rx = napData.nivel_senal_rx;
    }

    if (vinetaData && vinetaData.vineta_serial) {
      payload.vineta_serial = vinetaData.vineta_serial;
    }
    if (fichaNumero) {
      payload.ficha = String(fichaNumero);
    }

    // AGREGAR LAS FOTOS AL PAYLOAD
    if (fotos && fotos.length > 0) {
      payload.fotos = fotos;
    }

    const response = await axios.post(`/tickets/${ticketId}/close-installation`, payload);
    return response.data;
  },


  // Cerrar ticket de retiro (MEJORADO con fotos y ubicación)
  closeRetiroTicket: async (ticketId, payload) => {
      console.log('🔵🔵🔵 API - closeRetiroTicket INICIADO 🔵🔵🔵');
      console.log('🔵 API - ticketId:', ticketId);
      console.log('🔵 API - payload recibido completo:', JSON.stringify(payload, null, 2));
      console.log('🔵 API - payload.equipos:', payload?.equipos);
      console.log('🔵 API - payload.equipos.length:', payload?.equipos?.length || 0);
      console.log('🔵 API - payload.materiales:', payload?.materiales);
      console.log('🔵 API - payload.materiales.length:', payload?.materiales?.length || 0);
      console.log('🔵 API - payload.motivo_retiro:', payload?.motivo_retiro);
      console.log('🔵 API - payload.fotos:', payload?.fotos?.length || 0);
      console.log('🔵 API - payload.ubicacion:', payload?.ubicacion);

      // ✅ Verificar que el payload tenga materiales
      if (!payload.materiales || payload.materiales.length === 0) {
          console.warn('⚠️⚠️⚠️ API - EL PAYLOAD NO TIENE MATERIALES ⚠️⚠️⚠️');
          console.warn('API - Esto significa que el frontend no está enviando materiales');
          console.warn('API - Revisa el estado "materiales" en CloseRetiroDialog');
      } else {
          console.log('✅ API - Materiales encontrados en payload:', payload.materiales.length);
          console.log('✅ API - Detalle de materiales:', JSON.stringify(payload.materiales, null, 2));
      }

      try {
          const response = await axios.post(`/tickets/${ticketId}/close-retirement`, payload);
          console.log('✅ API - Respuesta exitosa:', response.data);
          return response.data;
      } catch (error) {
          console.error('❌ API - Error en la petición:', error);
          console.error('❌ API - Error response:', error.response);
          throw error;
      }
  },
  // Cerrar ticket de cambio de equipo (MEJORADO con fotos y ubicación)
  closeCambioEquipoTicket: async (
    ticketId,
    equiposViejos,
    equiposNuevos,
    materialesUtilizados,
    motivoCambio,
    fotos = [],
    ubicacion = null,
    vinetaNueva = undefined,
    vinetaRetirar = false
  ) => {
    console.log('📦 MATERIALES en API:', JSON.stringify(materialesUtilizados, null, 2));
    console.log('🏷️ Viñeta nueva:', vinetaNueva);
    console.log('🏷️ Retirar viñeta:', vinetaRetirar);

    const payload = {
      equipos_viejos: equiposViejos || [],
      equipos_nuevos: equiposNuevos || [],
      materiales_utilizados: materialesUtilizados || [],
      materiales_raw: materialesUtilizados || [],
      motivo_cambio: motivoCambio || '',
      motivo_retiro: motivoCambio || '', // Para compatibilidad
      new_equipment_sn: equiposNuevos?.length > 0 ? equiposNuevos[0].sn : null
    };

    if (vinetaNueva) {
      payload.vineta_nueva = vinetaNueva;
    }
    if (vinetaRetirar) {
      payload.vineta_retirar = vinetaRetirar;
    }
    // Agregar fotos si existen
    if (fotos && fotos.length > 0) {
      payload.fotos = fotos;
    }

    // Agregar ubicación si existe
    if (ubicacion && ubicacion.latitud && ubicacion.longitud) {
      payload.latitud = ubicacion.latitud;
      payload.longitud = ubicacion.longitud;
      payload.precision = ubicacion.precision || null;
      payload.ubicacion_obtenida_en = 'gps';
    }

    const response = await axios.post(`/tickets/${ticketId}/close-equipment-change`, payload);
    return response.data;
  },

  // ✅ NUEVO: Generar PDF de incidente
  generateIncidentPDF: async (ticketId) => {
    const response = await axios.post(`/tickets/${ticketId}/generate-incident-pdf`, {}, {
      responseType: 'blob'
    });
    return response;
  },

  // Generar PDF de instalación
  generateInstallationPDF: async (ticketId) => {
    const response = await axios.post(`/tickets/${ticketId}/generate-installation-pdf`, {}, {
      responseType: 'blob'
    });
    return response;
  },

  // Generar PDF de retiro (NUEVO)
  generateRetirementPDF: async (ticketId) => {
    const response = await axios.post(`/tickets/${ticketId}/generate-retirement-pdf`, {}, {
      responseType: 'blob'
    });
    return response;
  },

  // Generar PDF de cambio de equipo (NUEVO)
  generateEquipmentChangePDF: async (ticketId) => {
    const response = await axios.post(`/tickets/${ticketId}/generate-equipment-change-pdf`, {}, {
      responseType: 'blob'
    });
    return response;
  },
};

